import React from "react";
import PropTypes from "prop-types";

export default function RawButton({ innerRef, css, ...props }) {
  return (
    <button
      type="button"
      ref={innerRef}
      css={{
        marginLeft: 15,
        padding: 0,
        background: "none",
        border: 0,
        display: "flex",
        outline: 0,
        cursor: "pointer",
        ...css,
      }}
      {...props}
    />
  );
}

RawButton.propTypes = {
  innerRef: PropTypes.func,
  css: PropTypes.object,
};

RawButton.defaultProps = {
  innerRef: null,
  css: {},
};
